export default "__VITE_PUBLIC_ASSET__55216548__"